import React from 'react'
import { Container } from 'react-bootstrap'
import { ExerciseStatus } from '../../../constants/exercises'
import { RnExerciseSet, RnExercise as RnExerciseType } from '../rnSlice'
import RnLevelChooser from './RnLevelChooser'
import RnExercise from './RnExercise'

export interface IRnProgressProps {
  status: ExerciseStatus
  exercises: RnExerciseType[]
  level?: number
  currentExercise: number
  currentSet: number
  currentExerciseSet?: RnExerciseSet
  answer?: number
  pickAnswer: (choice: number) => void
  next: () => void
  start: (level: number) => void
}


const RnProgress = ({ status, exercises, level, currentExercise, currentSet, currentExerciseSet, answer, pickAnswer, next, start }: IRnProgressProps) => {

  if (status !== 'in-progress' ) { return null }

  const hasSelectedLevel = currentExerciseSet !== undefined

  return (
    <>
      <Container>
        <h3>Exercise {currentExercise}</h3>
      </Container>
      <RnLevelChooser
        hidden={hasSelectedLevel}
        exercises={exercises}
        pickLevel={start}
      />
      <RnExercise
        currentSet={currentSet}
        level={level}
        exerciseSet={currentExerciseSet}
        answer={answer}
        pickAnswer={pickAnswer}
        next={next}
      />
    </>
  )
}

export default RnProgress